import 'jquery';
import 'lightbox2';

import './_components/_individual-use-header';
import './_components/_repair-form-link';
